import { createResource } from "~/lib/resourceFactory";
import { getTelegramLinkStatus } from "./telegram-link.api";

type TelegramLinkStatusData = Awaited<ReturnType<typeof getTelegramLinkStatus>>;

export const telegramLinkStatusResource = createResource<
  TelegramLinkStatusData,
  undefined
>({
  key: (_) => ["telegram-link", "status"] as const,
  fetcher: (_) => getTelegramLinkStatus(),
});
